export default "__VITE_ASSET__CGNQrfoJ__"